import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('put', `/api/courses/${id}/toggle_chat`, payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/toggleCourseChat.js